import getLocalWishlist from '../utils/getLocalWishlist';
import getProductGidByHandle from '../utils/requests/getProductGidFromHandle';
import updateRemoteWishlist from '../utils/requests/updateRemoteWishlist';
import CONSTANTS from '../utils/vars/CONSTANTS';
import SELECTORS from '../utils/vars/SELECTORS';

if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateWishlistState(false);
      this.initializeEventListeners();
    }

    get button() {
      return this.querySelector('button');
    }

    get productHandle() {
      return this.button?.dataset.productHandle;
    }

    get localWishlist() {
      return getLocalWishlist();
    }

    initializeEventListeners() {
      if (!this.button) return;

      this.button.disabled = false;
      this.button.addEventListener('click', this.handleWishlistToggle.bind(this));
    }

    handleWishlistToggle() {
      this.updateWishlistState();
    }

    async updateWishlistState(shouldChangeState = true) {
      const wishlist = this.localWishlist;
      const productIndex = wishlist.indexOf(this.productHandle);
      let isActive = productIndex !== -1;

      if (shouldChangeState) {
        if (isActive) {
          const wishlistConfirmation = this.querySelector(SELECTORS.WISHLIST_REMOVE_CONFIRMATION_WRAPPER);
          if (wishlistConfirmation) {
            wishlistConfirmation.classList.remove('-translate-y-full');
            const removeWishlistButton = wishlistConfirmation.querySelector(SELECTORS.WISHLIST_REMOVE_CONFIRMATION_CONFIRM);
            const cancelWishlistButton = wishlistConfirmation.querySelector(SELECTORS.WISHLIST_REMOVE_CONFIRMATION_CANCEL);
            removeWishlistButton.addEventListener('click', async (e) => {
              e.preventDefault();
              wishlist.splice(productIndex, 1);

              isActive = !isActive; // Toggle the state
              this.saveWishlistToLocalStorage(wishlist);
              this.updateButtonAppearance(isActive);
              wishlistConfirmation.classList.add('-translate-y-full');

              await this.syncRemoteWishlist();
            });
            cancelWishlistButton.addEventListener('click', async (e) => {
              e.preventDefault();
              wishlistConfirmation.classList.add('-translate-y-full');
            });
            this.setupClickOutsideListener(wishlistConfirmation);
          }
        } else {
          wishlist.push(this.productHandle);

          isActive = !isActive; // Toggle the state
          this.saveWishlistToLocalStorage(wishlist);
          this.updateButtonAppearance(isActive);

          await this.syncRemoteWishlist();
        }
      } else {
        this.updateButtonAppearance(isActive);
      }
    }

    setupClickOutsideListener(element) {
      const clickOutsideEventListener = (e) => {
        const clickedEl = e.target;
        if (clickedEl !== element && !element.contains(clickedEl)) {
          element.classList.add('-translate-y-full');
          document.body.removeEventListener('click', clickOutsideEventListener, true);
        }
      };

      document.body.addEventListener('click', clickOutsideEventListener, true);
    }

    saveWishlistToLocalStorage(wishlist) {
      const wishlistString = wishlist.join(CONSTANTS.LOCAL_STORAGE_DELIMITER);
      localStorage.setItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
    }

    async syncRemoteWishlist() {
      if (CONSTANTS.CUSTOMER_LOGGED_IN) {
        const productGid = await getProductGidByHandle(this.productHandle);
        if (productGid) await updateRemoteWishlist(productGid);
      }
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }

    updateButtonAppearance(isActive) {
      if (isActive) {
        this.classList.add(CONSTANTS.BUTTON_ACTIVE_CLASS);
      } else {
        this.classList.remove(CONSTANTS.BUTTON_ACTIVE_CLASS);
      }
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}
